module.exports = __webpack_public_path__ + "static/media/ta-06.b4c744b5.png";